var map = {
	"./avatar.svg": "6108",
	"./canvas-obj-bottom.svg": "662a",
	"./canvas-obj-down.svg": "6600",
	"./canvas-obj-top.svg": "1b65",
	"./canvas-obj-up.svg": "c193",
	"./clear.svg": "909a",
	"./delete.svg": "a3dd",
	"./deploy.svg": "05b1",
	"./devices.svg": "7648",
	"./dongcha.svg": "5be4",
	"./elevator.svg": "f103",
	"./elevator2.svg": "ab42",
	"./ellipsis.svg": "7f90",
	"./escalator.svg": "61fb",
	"./escalator2.svg": "4315",
	"./example.svg": "b6f9",
	"./eye.svg": "57fa",
	"./feedback.svg": "3fcf",
	"./flow.svg": "4f45",
	"./form.svg": "4576",
	"./help.svg": "86c0",
	"./home.svg": "0331",
	"./icon-copy.svg": "51bf",
	"./icon-delete.svg": "fd76",
	"./icon-edit.svg": "7d44",
	"./icon-save.svg": "d8cd",
	"./icon-top.svg": "6ac8",
	"./line-down.svg": "9ba6",
	"./line-up.svg": "a4aa",
	"./line.svg": "a6d9",
	"./link.svg": "5fda",
	"./location.svg": "87a1",
	"./logo.svg": "d9b6",
	"./minus.svg": "ae17",
	"./nested.svg": "91be",
	"./password.svg": "198d",
	"./pause.svg": "b849",
	"./place.svg": "552d",
	"./plus.svg": "701f",
	"./point.svg": "ad95",
	"./polygon.svg": "2a59",
	"./project.svg": "f61c",
	"./redo.svg": "1da2",
	"./rotateLeft.svg": "7837",
	"./rotateRight.svg": "174e",
	"./route.svg": "62de",
	"./rule.svg": "4820",
	"./scaleMinus.svg": "3fa8",
	"./scalePlus.svg": "de0d",
	"./screen.svg": "91d2",
	"./screen2.svg": "ecf6",
	"./statistics.svg": "7e06",
	"./table.svg": "dc78",
	"./time.svg": "f8e6",
	"./tree.svg": "0e8f",
	"./undo.svg": "18d6",
	"./user.svg": "d88a",
	"./一人一档.svg": "0f1e",
	"./主题切换.svg": "3a1c",
	"./刷新.svg": "ccc5",
	"./区域分析.svg": "a945",
	"./商品监控.svg": "b433",
	"./头像.svg": "f8b8",
	"./客流分析.svg": "cb2c",
	"./展开.svg": "5ff1",
	"./店铺分析.svg": "8808",
	"./收起.svg": "0283",
	"./清空.svg": "f175",
	"./用户管理.svg": "51d3",
	"./语言.svg": "a195",
	"./调整.svg": "dc7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";